import * as React from "react";
import { IProductAuthor } from "~/types/product";
import TruncateMarkup from "react-truncate-markup";
import classNames from "classnames";

interface IProductAuthorProps {
    authors?: IProductAuthor[];
    maxLines?: number;
    className?: string;
}

const ProductAuthors: React.FC<IProductAuthorProps> = ({ authors, className, maxLines }) => {
    if (!authors?.length) {
        return null;
    }

    const baseClass = "product-authors";
    const classes = classNames(baseClass, className);

    const Wrapper: React.FC = ({ children }) =>
        maxLines ? (
            <TruncateMarkup lines={maxLines}>{children}</TruncateMarkup>
        ) : (
            <React.Fragment>{children}</React.Fragment>
        );

    return (
        <Wrapper>
            <ul className={classes}>
                {authors.map((author, index) => {
                    return (
                        <li key={index} className={`${baseClass}__item`}>
                            {author.url ? (
                                <a href={author.url} title={author.name}>
                                    {author.name}
                                </a>
                            ) : (
                                <span>{author.name}</span>
                            )}
                        </li>
                    );
                })}
            </ul>
        </Wrapper>
    );
};

export default ProductAuthors;
